import { Routes } from "@angular/router";
import { autoLoginPartialRoutesGuard } from "angular-auth-oidc-client";

import { PlanMonthComponent, RedirectComponent } from "@shared/components";
import {
  HistoryComponent,
  HomeComponent,
  ActivePlanComponent,
  SettingsComponent,
  ChartsComponent,
  StandbyPlanComponent,
  AboutComponent,
} from "@features/index";
import { ChartPageComponent } from "@features/charts/components/chart-page/chart-page.component";
import { OptionsComponent } from "@features/standby-plan/components/options/options.component";
import { FeedbackComponent } from "@features/about/components/feedback/feedback.component";
import { VersionsComponent } from "@features/about/components/versions/versions.component";
import { KnownIssuesComponent } from "@features/about/components/known-issues/known-issues.component";
import { FaqComponent } from "@features/about/components/faq/faq.component";
import { PvdsComponent } from "@features/settings/components/pvds/pvds.component";
import { VmaxComponent } from "@features/settings/components/vmax/vmax.component";
import { ProjComponent } from "@features/settings/components/proj/proj.component";

const autoLoginGuard = [autoLoginPartialRoutesGuard];

export const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  { path: "redirect", component: RedirectComponent },
  { path: "home", component: HomeComponent, canActivate: autoLoginGuard },
  { path: "active", component: ActivePlanComponent, canActivate: autoLoginGuard },
  { path: "standby", component: StandbyPlanComponent, canActivate: autoLoginGuard },
  { path: "standbyoptions", component: OptionsComponent, canActivate: autoLoginGuard },
  { path: "planmonth/:planKey/:effectivePeriod", component: PlanMonthComponent, canActivate: autoLoginGuard },
  { path: "history", component: HistoryComponent, canActivate: autoLoginGuard },
  { path: "charts", component: ChartsComponent, canActivate: autoLoginGuard },
  { path: "charts/:chartType", component: ChartPageComponent, canActivate: autoLoginGuard },
  { path: "about", component: AboutComponent, canActivate: autoLoginGuard },
  { path: "about/versions", component: VersionsComponent, canActivate: autoLoginGuard },
  { path: "about/knownissues", component: KnownIssuesComponent, canActivate: autoLoginGuard },
  { path: "about/feedback", component: FeedbackComponent, canActivate: autoLoginGuard },
  { path: "about/faq/:category", component: FaqComponent, canActivate: autoLoginGuard },
  { path: "settings", component: SettingsComponent, canActivate: autoLoginGuard },
  { path: "settings/pvds", component: PvdsComponent, canActivate: autoLoginGuard },
  { path: "settings/vmax", component: VmaxComponent, canActivate: autoLoginGuard },
  { path: "settings/proj", component: ProjComponent, canActivate: autoLoginGuard },
];
